<template>
    <div class="g pop-up-inner">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            caption="欄位顯示設定"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <div class="md major-table is-drop">
                    <table>
                        <tbody>
                            <tr>
                                <th class="drop-td">
                                    <div class="in">
                                        <a>拖曳</a>
                                    </div>
                                </th>
                                <th>
                                    <div class="in">
                                        <a>名稱</a>
                                    </div>
                                </th>
                                <th>
                                    <div class="in">
                                        <a>顯示</a>
                                    </div>
                                </th>
                            </tr>
                            <template v-for="(set, index) in node">
                                <tr
                                    :key="index"
                                    :class="[catchNode == set? 'is-border-'+ away :'']"

                                    draggable="true"

                                    @dragstart="startDropStatus(set, $event)"
                                    @dragend="endDropStatus(set, $event)"
                                >
                                    <td class="drop-td">
                                        <div class="in">
                                            <div class="sensor">
                                                <div class="top"
                                                    @drop.prevent="changeData('top', set, $event)"
                                                    @dragover.prevent="movingStart('top', set, $event)"
                                                    @dragleave.prevent="movingEnd"
                                                ></div>
                                                <div class="bottom"
                                                    @drop.prevent="changeData('bottom', set, $event)"
                                                    @dragover.prevent="movingStart('bottom', set, $event)"
                                                    @dragleave.prevent="movingEnd"
                                                ></div>
                                            </div>
                                            <a></a>
                                        </div>
                                    </td>
                                    <td title="名稱">
                                        <div class="in">{{ set.caption }}</div>
                                    </td>
                                    <td title="顯示">
                                        <div class="in">
                                            <div class="sets">
                                                <div class="cp input checkbox dot-only">
                                                    <input type="checkbox" v-model="set.visible" :id="'show-'+ set.prop" :name="'show-'+ set.prop">
                                                    <label :for="'show-'+ set.prop"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </div>
</template>

<script>
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import mdBtnList from '@/components/mdBtnList'

    export default {
        components: {
            mdCaption,
            mdToggleAside,
            mdBtnList,
        },
        props: {
            sn: {
                require: true
            },
            content: {
                type: Object,
                require: true
            }
        },
        data: function(){
            let $content = this.content || {},
                $clone = _.cloneDeep($content.node);

            $clone.sort((a, b) => {

                if( a.sortnum > b.sortnum ) {
                    return 1;
                }else if( a.sortnum < b.sortnum ) {
                    return -1;
                }else {
                    return 0;
                }
            });

            return {
                node: $clone,
                moveNode: null, //開始拖曳的物件為何
                away: '', //拖曳的方向
                catchNode: null
            }
        },
        computed: {
            btns: function(){

                let $update = {
                        text: '更新',
                        themes: 'major',
                        func: 'update',
                    },
                    $revert = {
                        text: '重設',
                        func: 'revert',
                    },
                    $cancel = {
                        text: '取消',
                        func: 'close',
                    }

                return [
                    $update,
                    $revert,
                    $cancel,
                ]
            },
        },
        methods: {
            changeStatus: function(opt, visible){
                opt.visible = visible;
            },
            update: function(){
                let $_action = this.content.update,
                    $node = this.node;

                let $titleData = [];

                $node.forEach((node, index) => {

                    $titleData.push({
                        prop: node.prop,
                        sortnum: index + 1,
                        visible: node.visible
                    });
                });

                $_action($titleData);

                this.close();
            },
            revert: function(){
                let $_action = this.content.revert;

                $_action();

                this.close();
            },
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            },
            startDropStatus: function(obj, e){
                e.dataTransfer.setData('Text', ''); //firefox

                this.moveNode = obj;
                this.addClass(e.target);
            },
            endDropStatus: function(obj, e){
                this.moveNode = null;
                this.away = '';
                this.catchNode = null;
                this.removeClass(e.target)
            },
            changeData: function(away, obj, e){
                this.removeClass(e.target);

                let $content = this.node,
                    $moveNode = this.moveNode,
                    $catchNode = this.catchNode;

                if( $moveNode !== $catchNode ) {

                    let _moveNodeIndex = $content.indexOf($moveNode);

                    $content.splice(_moveNodeIndex, 1); //先移除自己

                    let _catchNodeIndex = $content.indexOf($catchNode);

                    if( away === 'top' ){
                        $content.splice(_catchNodeIndex, 0, $moveNode);
                    }else if( away === 'bottom' ) {
                        $content.splice(_catchNodeIndex + 1, 0, $moveNode);
                    }
                }

                this.endDropStatus(obj, e);
            },
            movingStart: function(away, obj, e){ //滑入物件加 class 改變顏色
                this.catchNode = obj;
                this.away = away;
                this.addClass(e.target);
            },
            movingEnd: function(e){ //滑入物件刪除 class 改變顏色
                this.catchNode = null;
                this.away = '';
                this.removeClass(e.target);
            },
            addClass: function(target){ //滑入物件加 class 改變顏色
                target.classList.add('is-drop');
            },
            removeClass: function(target){ //滑入物件刪除 class 改變顏色
                target.classList.remove('is-drop');
            }
        }
    }
</script>

<style scoped lang="scss">

    .sets {

        span {
            cursor: pointer;
        }
    }
</style>
